<template>
  <span>
    <a-badge
      count="Approved"
      v-if="approvalStatus === 'APPROVED'"
      :number-style="{ backgroundColor: '#52c41a' }"
    />
    <a-badge count="Rejected" v-else-if="approvalStatus === 'REJECTED'" />
    <a-badge
      count="Editing"
      v-else-if="approvalStatus === 'EDITING'"
      :number-style="{ backgroundColor: 'rgb(250, 173, 21)' }"
    />
  </span>
</template>
<script>
export default {
  props: {
    approvalStatus: {
      type: String,
    },
  },
  data() {
    return {};
  },
  methods: {},
};
</script>
<style lang="css" scoped></style>
